/** Initialen aus einem Anzeigenamen: erste Buchstaben der ersten zwei Wörter. */
export function initials(name?: string): string {
  return (name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
}

/** Initialen aus Vor-/Nachname (vCard). Fällt auf „–" zurück. */
export function initialsOf(firstName?: string, lastName?: string): string {
  return ((firstName?.[0] || '') + (lastName?.[0] || '')).toUpperCase() || '–'
}
